module.exports = __webpack_public_path__ + "media.79c412bc21ecf6e7e14c.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/benge/Angular/my-first-app/src/assets/images/media.jpg
// module id = ../../../../../src/assets/images/media.jpg
// module chunks = main